import { viperApi, clinicalApiPath } from '@/services/viper-api'
import qs from 'qs'

const cases = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/cases`,

  get(organizationId, caseId, includeTags) {
    const path =
      this.basePath(organizationId) +
      `/${caseId}` +
      (includeTags === true ? '?includeTags=true' : '')
    return viperApi.get(path)
  },

  list(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' })
      }
    })
  },

  filters(organizationId) {
    return viperApi.get(this.basePath(organizationId) + '/filters')
  },

  create(cs) {
    return viperApi.post(`${this.basePath(cs.organization.id)}/new`, cs)
  },

  update(cs) {
    return viperApi.put(this.basePath(cs.organization.id) + `/${cs.id}`, cs)
  }
}

const caseSlides = {
  resourcePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/case-slides`,

  search(organizationId, caseId) {
    return viperApi.get(this.resourcePath(organizationId) + `?pathCase.id=${caseId}`)
  },

  create(caseSlide) {
    return viperApi.post(this.resourcePath(caseSlide.pathCase.organization.id), caseSlide)
  },

  delete(organizationId, caseSlideId) {
    return viperApi.delete(this.resourcePath(organizationId) + `/${caseSlideId}`)
  }
}

const fieldOptions = {
  basePath: fieldId => `${clinicalApiPath}/fields/${fieldId}/options`,

  search(fieldId) {
    return viperApi.get(this.basePath(fieldId))
  }
}

const fieldOptionsAliases = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/option-aliases`,

  search(organizationId, fieldId) {
    return viperApi.get(this.basePath(organizationId) + `?fieldOption.fieldId=${fieldId}`)
  }
}

export default {
  cases,
  caseSlides,
  fieldOptions,
  fieldOptionsAliases
}
